"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _calicoUiKit = require("@calico/calico-ui-kit");

var _reactRouterDom = require("react-router-dom");

var Navigation = function Navigation(_ref) {
  var className = _ref.className,
      items = _ref.items,
      style = _ref.style;
  return _react.default.createElement("nav", {
    className: (0, _classnames.default)('navigation-tabs font-size-small padding-top-2 padding-bottom-2', className),
    style: (0, _extends2.default)({
      top: 0
    }, style)
  }, items.map(function (item, i) {
    if (item.content) {
      return _react.default.createElement("div", {
        key: i
      }, item.content);
    }

    return _react.default.createElement(_reactRouterDom.NavLink, {
      key: i,
      activeClassName: "active",
      exact: true,
      to: item.path
    }, item.name);
  }));
};

Navigation.defaultProps = {
  items: [{
    name: 'Home',
    path: '/'
  }]
};
var _default = Navigation;
exports.default = _default;